function lazyLoadLoad( elm: HTMLElement ) {
	return new Promise( resolve => {
		const load = ( entries: IntersectionObserverEntry[], observer: IntersectionObserver ) => {
			entries.forEach( entry => {
				if ( entry.intersectionRatio > 0 ) {
					observer.unobserve( entry.target );
					resolve( elm );
				}
			} );
		}

		const observer = new IntersectionObserver( load, { root: null, rootMargin: '0px', threshold: 0.1 } );
		observer.observe( elm );
	});
}

export function lazyLoad( elm: HTMLElement ) {
	return new Promise(resolve => {
		if ( 'requestIdleCallback' in window ) {
			window.requestIdleCallback( () => {
				lazyLoadLoad( elm ).then( r => {
					resolve( r );
				})
			}, { timeout: 500 } );
		} else {
			return lazyLoadLoad( elm ).then( r => {
				resolve( r );
			} );
		}
	} );
}

/*
this.innerHTML = `<div class='fixed top-1/2 left-1/2  transform -translate-x-1/2 -translate-y-1/2 z-[10000] flex justify-center items-center'>
	  <div class='animate-spin rounded-full h-64 w-64 border-b-2 border-primary-700'></div>
	</div>`;
*/

export const components = {
	// Mainnavigation
	'swt-mainnavigation-mobile': ( elm: HTMLElement ) => new Promise( res => {
		import( './mainnavigation/mobile').then( comp => {
			res( comp );
		} )
	} ),
	'swt-mainnavigation-fixed': ( elm: HTMLElement ) => new Promise( res => {
		import( './mainnavigation/fixed' ).then( comp => {
			res( comp );
		} )
	} ),
	'swt-mainnavigation-flyout': ( elm: HTMLElement ) => new Promise( res => {
		lazyLoad( elm ).then( () => {
			import( './mainnavigation/flyout' ).then( comp => {
				res( comp );
			} );
		} );
	} ),
	'swt-immo-listing-search': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	}),
	'swt-immo-listing-object': (elm: HTMLElement) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-listing-map': (elm: HTMLElement) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-expose-gallery': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-expose-pdf-button': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-expose-form': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-saved-search': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-lead': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-immo-app': ( elm: HTMLElement ) => new Promise( res => {
		import( './immo' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-tabs': ( elm: HTMLElement ) => new Promise( res => {
		import( './tabs' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-review-edit-rating': ( elm: HTMLElement ) => new Promise( res => {
		import( './review' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-reviews-star-rating': ( elm: HTMLElement ) => new Promise( res => {
		import( './review' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-reviews-authenticity': ( elm: HTMLElement ) => new Promise( res => {
		import( './review' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-readmore': ( elm: HTMLElement ) => new Promise( res => {
		import( './readmore' ).then( comp => {
			res( comp );
		} );
	} ),
	'swt-readmore-button': ( elm: HTMLElement ) => new Promise( res => {
		import( './readmore' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-map': ( elm: HTMLElement ) => new Promise( res => {
		import( './map' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-modal': ( elm: HTMLElement ) => new Promise( res => {
		lazyLoad( elm ).then( () => {
			import( './modal' ).then( comp => {
				res( comp );
			} );
		} );
	} ),

	'swt-table': ( elm: HTMLElement ) => new Promise( res => {
		import( './table' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-counter': ( elm: HTMLElement ) => new Promise( res => {
		lazyLoad( elm ).then( () => {
			import( './counter' ).then( comp => {
				res( comp );
			} );
		} );
	} ),

	'swt-sticky-box': ( elm: HTMLElement ) => new Promise( res => {
		import( './sticky-box' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-slider': ( elm: HTMLElement ) => new Promise(res => {
		import( './slider' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-slider-hero': ( elm: HTMLElement ) => new Promise(res => {
		import( './slider-hero' ).then( comp => {
			res( comp );
		} );
	} ),

	'swt-demo-ui': ( elm: HTMLElement ) => new Promise( res => {
		import( './demo' ).then( comp => {
			res( comp );
		} )
	} ),

	'swt-accordion': ( elm: HTMLElement ) => new Promise( res => {
		import( './accordion' ).then( comp => {
			res( comp );
		} )
	} ),

	'swt-core': ( elm: HTMLElement ) => new Promise( res => {
		import( './core' ).then( comp => {
			res( comp );
		} )
	} ),

	'swt-iframe-resizer': ( elm: HTMLElement ) => new Promise( res => {
		import( './iframe-resizer' ).then( comp => {
			res( comp );
		} )
	} ),

	'swt-iframe-form-loader': ( elm: HTMLElement ) => new Promise( res => {
		import( './iframe-form-loader' ).then( comp => {
			res( comp );
		} )
	} ),
};
